import { isEqual, keys, pick } from 'lodash-es'

import { Proposer } from '../../../domain'

export const hasChanges = (
  original: Proposer | undefined,
  update: Partial<Proposer>,
): boolean => !isEqual(update, pick(original, keys(update)))
